import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get('/api/mobile/notifications', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error('Fetch notifications error:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const token = localStorage.getItem('crm_token');
      await axios.put(`/api/mobile/notifications/${id}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(notifications.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    } catch (error) {
      console.error('Mark as read error:', error);
    }
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div>
      <div className="header">
        <h1 className="page-title">Bildirimler</h1>
      </div>
      
      <div className="card">
        {notifications.length === 0 ? (
          <p className="text-muted" style={{ padding: '24px' }}>Henüz bildirim bulunmuyor.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {notifications.map(n => (
              <div 
                key={n.id} 
                style={{ 
                  padding: '16px 24px', 
                  borderBottom: '1px solid #e2e8f0',
                  background: n.is_read ? 'white' : '#f8fafc',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                <div>
                  <div style={{ fontWeight: n.is_read ? 500 : 700, color: '#1e293b', marginBottom: '4px' }}>
                    {n.type === 'info' && 'ℹ️ '}
                    {n.type === 'warning' && '⚠️ '}
                    {n.type === 'success' && '✅ '}
                    {n.title}
                  </div>
                  <div style={{ color: '#64748b', fontSize: '0.9rem' }}>{n.message}</div>
                  <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginTop: '8px' }}>
                    {format(new Date(n.created_at), 'dd/MM/yyyy HH:mm')}
                  </div>
                </div>
                {!n.is_read && (
                  <button className="btn btn-secondary btn-sm" onClick={() => markAsRead(n.id)}>
                    Okundu İşaretle
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notifications;
